import StartIcon from './component.jsx'
export default StartIcon
